export const views = {
    now: -1,
    hour: 0,
    day: 1,
    week: 2,
    month: 3,
    year: 4,
}

/**
 * Convert a "date" to a view
 *
 * @param string date A valid date string that is either 'now' or in format "YYYY[/MM/DD/HH]" or in format "YYYY/week/##"
 * @return string One of the possible view strings ('now', 'hour', 'day', 'week', 'month', 'year')
 *
 * @example 2020
 * @example 2020/06
 * @example 2020/06/18
 * @example 2020/06/18/11
 * @example 2020/week/15
 * @example now
 */
export const getViewFromDate = (date) => {
    if (date.includes('week')) {
        return 'week'
    }

    if (date.includes('now')) {
        return 'now'
    }

    return {
        0: 'year',
        1: 'month',
        2: 'day',
        3: 'hour',
    }[(date.match(/\//g) || []).length]
}